
// internal fucntion to null patter for images
// if images is [] then this object will apply.
const _checkNullpattern = (images) => {
  const [firtImage] = images;
  const nullObject = {
    filePath: undefined,
    showJumboSwatch: false,
    swatchSpriteOffset: 0,
    swatchSpriteUrlIndex: 0,
  };
  return firtImage !== undefined ? firtImage : nullObject;
};

// Adapter made for images over rails
// it add a fake image at product.imagery.images
// the main idea is video over rail behave as alternate image.
const imagesAdapter = (data, images) => {
  const copyImages = [...images];
  const image = _checkNullpattern(copyImages);
  return {
    videoId: data.videoId,
    filePath: image.filePath,
    name: image.name,
    video: true,
    showJumboSwatch: image.showJumboSwatch,
    swatchSpriteOffset: image.swatchSpriteOffset,
    swatchSpriteUrlIndex: image.swatchSpriteUrlIndex,
  };
};

// curied function to use && operator.
// made to decrease the branch coverage.
const andFunctor = x => y => !!x && !!y;

// curied function to use with triple && operator.
// made to decrease branch coverage.
const andTriFunctor = x => y => z => !!x && !!y && !!z;

module.exports = {
  andFunctor,
  andTriFunctor,
  imagesAdapter,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/productModelHelper/PatternsUtils.js